import React from "react";
import Form from "react-bootstrap/Form";
import "./admin-group-create-panel.scss";
import PropTypes from "prop-types";

const AdminGroupFormRightColumnNew = ({
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  isView,
  setFieldValue,
  isEdit,
  isSuperAdmin,
  departments,
}) => {
  return (
    <Form.Row className="right-row">
      <Form.Group className="group-company-name">
        <Form.Label>Department Name</Form.Label>
        {isSuperAdmin && !isView ? (
          <Form.Control
            id="CompanyName"
            name="CompanyName"
            as="select"
            value={values?.CompanyName ?? ""}
            onChange={(e) => {
              const selectedName = e.target.value;
              const selectedDept = departments.find((d) => d.Name === selectedName);
              setFieldValue("CompanyName", selectedName);
              setFieldValue("CompanyId", selectedDept?.Id ?? 0);
            }}
            onBlur={handleBlur}
            disabled={isView}
          >
            <option value="">Select a Department</option>
            {departments.map((dept, index) => (
              <option key={index} value={dept.Name ?? dept}>
                {dept.Name ?? dept}
              </option>
            ))}
          </Form.Control>
        ) : (
          <Form.Control
            id="CompanyName"
            name="CompanyName"
            type="text"
            value={values?.CompanyName ?? ""}
            disabled
          />
        )}
      </Form.Group>

      <Form.Group className="group-email-id">
        <Form.Label>Group Email ID </Form.Label>
        <Form.Control
          id="Email"
          name="Email"
          type="email"
          placeholder="Enter the Group Email Address"
          value={values?.Email ?? ""}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.Email && errors.Email}
          disabled={isView}
        />
        <Form.Control.Feedback type="invalid" className="inline-error">
          {errors.Email}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="group-description">
        <Form.Label>Description</Form.Label>
        <Form.Control
          id="Description"
          value={values?.Description ?? ""}
          onChange={handleChange}
          onBlur={handleBlur}
          as="textarea"
          placeholder="Enter Description"
          className="group-textarea"
          isInvalid={touched.Description && errors.Description}
          disabled={isView}
        />
        <Form.Control.Feedback type="invalid" className="inline-error">
          {errors.Description}
        </Form.Control.Feedback>
      </Form.Group>

      {isEdit && (
        <Form.Group className="group-edit-status">
          <Form.Label> Status </Form.Label>
          <Form.Check
            className="group-active-status"
            type="checkbox"
            name="formHorizontalRadios"
            checked={values?.Active}
            onChange={(e) => {
              handleChange(e);
              setFieldValue("Active", true);
            }}
            label="Active"
            disabled={isView}
          />
          <Form.Check
            className="group-inactive-status"
            type="checkbox"
            name="formHorizontalRadios"
            checked={!values?.Active}
            onChange={(e) => {
              handleChange(e);
              setFieldValue("Active", false);
            }}
            label="Inactive"
            disabled={isView}
          />
          <Form.Control.Feedback type="invalid" className="inline-error">
            {errors.Active}
          </Form.Control.Feedback>
        </Form.Group>
      )}
    </Form.Row>
  );
};

AdminGroupFormRightColumnNew.propTypes = {
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isView: PropTypes.bool.isRequired,
  handleBlur: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  isSuperAdmin: PropTypes.bool.isRequired,
  departments: PropTypes.array.isRequired,
};

export default AdminGroupFormRightColumnNew;
